import { render, staticRenderFns } from "./RentalServiceCostAllocator.yaml?vue&type=template&id=12781ff2&component"
import script from "./RentalServiceCostAllocator.yaml?vue&type=script&lang=ts&component"
export * from "./RentalServiceCostAllocator.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports